/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_Languages {
    Danish = 10,
    English = 20,
    German = 30,
}
